export const questions = [
    {
        questionText:"- Have you met the Proposer & Life to be Insured personally? (Yes/No)",
        questionId: "Q1",
        answer: "",
        additionalInformation: "",
        type:"radio"
    },
    {
        questionText:"- Have you explained the Product features, benefits, premium paying term & other relevant terms and conditions specified for the proposed product?",
        questionId: "Q2",
        answer: "",
        additionalInformation: "",
        type:"radio"
    },
    {
        questionText:"- Does the Life to be Insured have existing Life/Health/Critical illness cover from other insurance companies? If Yes, please provide the details.",
        questionId: "Q3",
        answer: "",
        additionalInformation: "",
        type:"radio",
        subQuestions:[
            {
                questionText:"Does the proposer/life to be insured have any Life or Critical Illness insurance policy issued or pending approval from any other insurance company or has the proposer/L2BI’s application for Life/Health/Critical Illness insurance or its reinstatement ever been offered at modified terms, rejected or postponed.",
                type:"label",
                questionId: " ",
            },
            {
                questionText:"Proposer/Joint Life ?",
                questionId:"i",
                answer:"",
                additionalInformation:"",
                options:['Yes','No'],
                type:"radioWithCustomOptions",
                required:"Yes"
            },
            {
                questionText:"Life to be assured.",
                questionId:"ii",
                answer:"",
                additionalInformation:"",
                options:['Yes','No'],
                type:"radioWithCustomOptions",
                required:"Yes"
            },
            {
                questionText:"Policy Status.",
                questionId:"iii",
                answer:"",
                additionalInformation:"",
                type:"radioWithCustomOptions",
                options:['Issued','Pending'],
                required:"Yes"
            },
            {
                questionText:"Please provide details if applicable:",
                questionId:"iv",
                answer:"",
                additionalInformation:"",
                type:"multipleTextFields",
                fields:[
                    {
                        placeholder:'Total Sum Assured for Life Insurance Cover',
                        value:'',
                        id:'field1'
                    }
                    ,{
                        placeholder:'Total Sum Assured for CI/DD Cover',
                        value:'',
                        id:'field2'
                    }
                ],
                required:"Yes"
            },
            {
                questionText:"Please select the appropriate option from below",
                questionId:"v",
                answer:"",
                additionalInformation:"",
                type:"radioWithCustomOptions",
                options:['Offered at modified terms','Rejected','Postponed'],
                required:"Yes"
            },
        ]
    },
    {
        questionText:"- Is there any adverse habit of the prospect or other significant findings regarding insurability (Age; health; personal habits; Occupation; hazardous avocation; premium paying capacity or other material information that may adversely affect the underwriting decision? If Yes, please provide the details.",
        questionId: "Q4",
        answer: "",
        additionalInformation: "",
        type:"radio"
    },
    {
        questionText:"- Did you observe any suspicious behavior or questions from the L2BI or proposer that you would like to disclose to the underwriter? If Yes, please provide the details.",
        questionId: "Q5",
        answer: "",
        additionalInformation: "",
        type:"radio"
    },
    {
        questionText:"- General health details of Life to be insured as observed.",
        type:"label",
        questionId: "Q6",
    },
    {
        questionText:" Physical handicap/ Deformity.",
        questionId: "Q6a",
        answer: "",
        additionalInformation: "",
        type:"radio",
        listStyleQuestion:"●"
    },
    {
        questionText:" Mental Retardation.",
        questionId: "Q6b",
        answer: "",
        additionalInformation: "",
        type:"radio",
        listStyleQuestion:"●"
    },
    {
        questionText:" History of current medical illness/ Surgery/hospitalization.",
        questionId: "Q6c",
        answer: "",
        additionalInformation: "",
        type:"radio",
        listStyleQuestion:"●"
    },
    {
        questionText:"- Do you want to make any other disclosure that may impact the underwriting decision? If Yes, please provide the details.",
        questionId: "Q7",
        answer: "",
        additionalInformation: "",
        type:"radio"
    },
]